<section class="users-section">
  <div class="container">

    <div class="card">
      <!-- Page Header -->
      <div class="page-header">
        <h3 class="page-title">Users</h3>

        <!-- ROLE FILTER BAR -->
        <div class="filter-bar">
          <select (change)="onRoleFilterChange($event)">
            <option value="">All Roles</option>
            <option *ngFor="let r of Roles" [value]="r.roleId">
              {{ r.name }}
            </option>
          </select>





          <button class="btn-secondary" type="button" (click)="resetFilter()">
            Reset
          </button>
        </div>

        <div class="flex-spacer"></div>

        <!-- Create User -->
        <button [routerLink]="projectId && ['/project-users', projectId, 'create-user']" [disabled]="!projectId"
          class="icon-btn create">
          <i class="fa-solid fa-plus"></i>
        </button>

      </div>

      <!-- USERS TABLE -->
      <div class="table-wrapper table-mobile-card">
        <table class="table" id="users-table">
          <thead>
            <tr>
              <th resizableColumn tableId="users-table" colKey="name">Name</th>
              <th resizableColumn tableId="users-table" colKey="email">Email</th>
              <th resizableColumn tableId="users-table" colKey="role">Role</th>
              <th resizableColumn tableId="users-table" colKey="creation" class="date-col">
                Creation Date
              </th>
              <th resizableColumn tableId="users-table" colKey="actions" class="action-col">
                View
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- EMPTY STATE -->
            <tr *ngIf="!Users || Users.length === 0">

              <td colspan="100%">
                <div class="no-data">
                  <i class="fa-regular fa-user"></i>
                  No users found
                </div>
              </td>
            </tr>

            <!-- DATA ROWS -->
            <tr *ngFor="let user of Users">
              <td data-label="Name">
                {{ user.name }}
              </td>

              <td data-label="Email">
                {{ user.email }}
              </td>

              <td data-label="Role">
                {{ user.role.name }}
              </td>

              <td data-label="Creation Date" class="date-col">
                {{ user.creationDate.split('T')[0] }}
              </td>

              <td data-label="Actions" class="action actions-cell">
                <button class="icon-btn view" (click)="viewUser(user.authUserId)">
                  <i class="fa-solid fa-eye"></i>
                </button>
              </td>

            </tr>
          </tbody>
        </table>

        <!-- GLOBAL PAGINATION -->
        <div class="pagination-bar">
          <div class="left">
            <label>Page Size : </label>
            <select [(ngModel)]="size" (change)="changeSize()">
              <option [value]="10">10</option>
              <option [value]="15">15</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
            </select>
          </div>

          <div class="center">
            Page {{ totalPages === 0 ? 0 : page + 1 }} / {{ totalPages }}
          </div>

          <div class="right">
            <button class="btn-page" (click)="prevPage()" [disabled]="page === 0">←</button>

            <button class="btn-page" (click)="nextPage()"
              [disabled]="page >= totalPages - 1 || totalPages === 0">→</button>
          </div>
        </div>

      </div>
    </div>

  </div>
</section>